import React from 'react';

const ArchiveIcon = ({ size = 16 }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 16 16" fill="none">
            <path d="M14 2H2C1.63181 2 1.33333 2.29848 1.33333 2.66667V4.66667C1.33333 5.03486 1.63181 5.33333 2 5.33333H14C14.3682 5.33333 14.6667 5.03486 14.6667 4.66667V2.66667C14.6667 2.29848 14.3682 2 14 2Z" stroke="currentColor" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M2.66667 5.33333V12.6667C2.66667 13.0203 2.80714 13.3594 3.05719 13.6095C3.30724 13.8595 3.64638 14 4 14H12C12.3536 14 12.6928 13.8595 12.9428 13.6095C13.1929 13.3594 13.3333 13.0203 13.3333 12.6667V5.33333" stroke="currentColor" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M6.66667 8H9.33333" stroke="currentColor" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

export default ArchiveIcon;
